// import { AgentBuilder } from '../components/tools/AgentBuilder'

export function AgentBuilderPage() {
  return (
    <main className="flex-1 p-4 overflow-y-auto">
      <div className="max-w-6xl mx-auto">
        <div className="p-8 text-center text-gray-400">Agent Builder temporarily disabled</div>
      </div>
    </main>
  )
}
